var React = require('react');

function MenuOutline (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"menu"},[React.createElement("rect",{"width":"24","height":"24","transform":"rotate(180 12 12)","opacity":"0","key":0}),React.createElement("rect",{"x":"3","y":"11","width":"18","height":"2","rx":".95","ry":".95","key":1}),React.createElement("rect",{"x":"3","y":"16","width":"18","height":"2","rx":".95","ry":".95","key":2}),React.createElement("rect",{"x":"3","y":"6","width":"18","height":"2","rx":".95","ry":".95","key":3})])));
}

MenuOutline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = MenuOutline;

MenuOutline.default = MenuOutline;
